<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc"><h1>Contents</h1><ol><li id="level1-titlepage"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></li>
<li id="level1-toc"><a href="#/toc">Contents</a></li>
<li id="level1-front3"><a href="#/front01">Copyright</a></li>
<li id="level1-front4"><a href="#/front02">Frontispiece</a></li>
<li id="level1-front5"><a href="#/front03"><em>Note on the Text</em></a></li>
<li id="level1-front6"><a href="#/front04">Preface</a></li>
<li id="c01"><a href="#/c01"><em>Lightness</em></a>
</li>
<li id="c02"><span href="#/c02" title="Link target outside of Sample"><em>Quickness</em></span>
</li>
<li id="c03"><span href="#/c03" title="Link target outside of Sample"><em>Exactitude</em></span>
</li>
<li id="c04"><span href="#/c04" title="Link target outside of Sample"><em>Visibility</em></span>
</li>
<li id="c05"><span href="#/c05" title="Link target outside of Sample"><em>Multiplicity</em></span>
</li>
<li id="level1-back17"><span href="#/back01" title="Link target outside of Sample"><em>Translator’s Note</em></span></li>
<li id="level1-back18"><span href="#/back02" title="Link target outside of Sample">Read More from Italo Calvino</span></li>
<li id="level1-back19"><span href="#/back03" title="Link target outside of Sample"><em>About the Author and Translator</em></span></li></ol></nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?670999f0